@if (nextScheduledProcessingDate()) {
  <div class="mb-5 text-right text-sm text-gray-500">
    <div>Najbliższe automatyczne przetwarzanie subskrypcji:</div>
    <div><app-date-time [date]="nextScheduledProcessingDate()!" /></div>
  </div>
}

<app-action-buttons [actions]="actions()" />
